// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 541) return "js/components/hero.js";
	if (chunkId === 622) return "js/elements/buttonMarquee'.js";
	if (chunkId === 79) return "js/components/LoopingText.js";
	if (chunkId === 142) return "js/components/ArticleFeed.js";
	if (chunkId === 7) return "js/components/ProjectFeed.js";
	if (chunkId === 145) return "js/components/ProjectArchive.js";
	// return url for filenames based on template
	return undefined;
};